module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAMAAAC7IEhfAAAAS1BMVEUAAAAStvQRt/YRuPUSuPUSt/QSt/QSt/QRufYTuPUTtvQUufURuPUSuPUSt/USuPURt/QRufYRuPUTuPYTt/ISuvgPufMRt/QSt/Qc+8kYAAAAGHRSTlMA4StL0NmG9lhPpTKhb6t9t3RoiVFGQsDt6z1cAAAAtUlEQVQ4y9XTyw6DIBCFYcQyBeWieCnv/6QNCZMptAmWhkX/nSffBlTWo5A3xG0oxn5Q8ZQn6HFTL5Cz1EhwxI03QmOtLKG01rzBKQQoIYQwtcPdubOEp3M7wl6nXmVqI7jhtvZ717e8JW5LMbJ/6Z4n4ibwSeOF165naoRyThmCZp41wtpHAT9Br7X8AAetlyu/AtYCJcBRwgOwymGor6FRKcggVxhCqnKYa1DkPQiuAmMdegID7DSgaF6tHgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/share/ic_s_code.png
// module id = CaEH
// module chunks = 31